module.exports = __webpack_public_path__ + "media/greenhouse-hd01.9415e786.mp4";